import React, { useState } from 'react';
import { 
  ShieldAlert, 
  FileText, 
  CreditCard, 
  Search, 
  Mail, 
  MessageCircle, 
  ChevronDown,
  ChevronUp
} from 'lucide-react';

/**
 * Компонент с требованиями к паролям на различных российских сервисах
 */
const PasswordRequirements = ({ serviceRequirements }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  // Иконки для разных сервисов
  const iconComponents = {
    'FileText': FileText,
    'CreditCard': CreditCard,
    'Search': Search,
    'Mail': Mail,
    'MessageCircle': MessageCircle
  };
  
  // Выбираем первые 3 элемента для отображения в свернутом виде
  const visibleServices = isExpanded 
    ? serviceRequirements 
    : serviceRequirements.slice(0, 3);

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm p-5 mb-8">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <ShieldAlert className="w-5 h-5 mr-2 text-violet-500" />
        Требования к паролям на популярных сервисах
      </h3>
      
      <div className="space-y-3">
        {visibleServices.map((service, index) => {
          const IconComponent = iconComponents[service.icon] || FileText;
          
          return (
            <div 
              key={index} 
              className="p-4 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700"
            >
              <div className="flex items-center mb-2">
                <IconComponent className="w-5 h-5 text-violet-500 mr-2" />
                <h4 className="text-sm font-medium text-gray-900 dark:text-white">
                  {service.name}
                </h4>
              </div>
              
              <ul className="text-xs text-gray-600 dark:text-gray-400 space-y-1 pl-7 list-disc">
                {service.requirements.map((req, reqIndex) => (
                  <li key={reqIndex}>{req}</li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
      
      {serviceRequirements.length > 3 && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="mt-4 flex items-center justify-center w-full text-sm text-violet-600 hover:text-violet-800 dark:text-violet-400 dark:hover:text-violet-300 font-medium"
        >
          {isExpanded ? (
            <>
              Показать меньше
              <ChevronUp className="w-4 h-4 ml-1" />
            </>
          ) : (
            <>
              Показать больше
              <ChevronDown className="w-4 h-4 ml-1" />
            </>
          )}
        </button>
      )}
      
      <div className="mt-4 p-3 bg-gray-50 dark:bg-gray-700/30 border border-gray-200 dark:border-gray-700 rounded-lg">
        <p className="text-xs text-gray-600 dark:text-gray-400">
          В России действуют требования ФСТЭК и ФСБ к защите персональных данных, которые обязывают компании устанавливать минимальные требования к сложности паролей пользователей. Многие организации требуют пароли длиной не менее 8 символов с использованием символов различных категорий.
        </p>
      </div>
    </div>
  );
};

export default PasswordRequirements;